(function () {
  if (customElements.get('ce-toaster') !== undefined && customElements.get('ce-toast') !== undefined) {
    return;
  }

  class Toaster extends HTMLParsedElement {
    constructor() {
      super();

      this.translateYOffset = null;
    }

    parsedCallback() {
      this.initMediaQuery();
    }

    initMediaQuery() {
      const mediaQuery = window.matchMedia('(min-width: 768px)');

      const handleChangeMediaQuery = () => {
        if (mediaQuery.matches) {
          this.translateYOffset = '16px';
        } else {
          this.translateYOffset = '-16px';
        }
      };

      handleChangeMediaQuery();
      mediaQuery.addEventListener('change', handleChangeMediaQuery);
    }

    makeToast(type, content, duration = 3000) {
      const toast = document.createElement('ce-toast');
      toast.setAttribute('duration', duration);
      toast.setAttribute('offset', this.translateYOffset);
      toast.className = 'bg-background block mb-4 opacity-0 pointer-events-auto pl-4 pr-11 py-4 relative rounded-other shadow-toast w-1/1';

      toast.innerHTML = `
        <output class="flex">
          <div class="flex-none pr-2">
            <div class="h-5 w-5">
              <svg viewBox="0 0 20 20" width="20">
                <use href="#icon-${type}-${Themu.settings.iconStyle}"></use>
              </svg>
            </div>
          </div>
          <div class="flex-1 pl-2">
            <p class="text-body-text text-sm">
              ${content}
            </p>
          </div>
        </output>
        <button
          class="button button--square absolute -right-0.5 top-0.5 px-4.5 text-body-text"
          tabindex="-1"
          aria-hidden="true"
          data-toast-button-dismiss
        >
          <svg viewBox="0 0 20 20" width="12">
            <use href="#icon-close-${Themu.settings.iconStyle}"></use>
          </svg>
        </button>
      `;

      this.appendChild(toast);
    }
  }

  class Toast extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        buttonDismiss: '[data-toast-button-dismiss]',
      };

      this.elements = null;

      this.duration = null;
      this.translateYOffset = null;
      this.animation = null;

      this.handleClickButtonDismiss = this.handleClickButtonDismiss.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    parsedCallback() {
      this.elements = {
        buttonDismiss: this.querySelector(this.selectors.buttonDismiss),
      };

      this.duration = parseInt(this.getAttribute('duration'));
      this.translateYOffset = this.getAttribute('offset');

      this.elements.buttonDismiss.addEventListener('click', this.handleClickButtonDismiss);
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);

      this.createStartAnimation();
    }

    disconnectedCallback() {
      this.elements.buttonDismiss.removeEventListener('click', this.handleClickButtonDismiss);
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
    }

    createStartAnimation() {
      const keyframes = [
        { opacity: 0, transform: `translateY(${this.translateYOffset})`, offset: 0.0 },
        { opacity: 1, offset: 0.5 },
        { opacity: 1, transform: 'translateY(0)', offset: 1.0 },
      ];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 300,
        easing: Themu.animation.easeIn,
        fill: 'both',
      };

      this.animation = this.animate(keyframes, options);
      this.animation.addEventListener('finish', () => {
        this.animation.commitStyles();
        this.animation.cancel();
        this.createMiddleAnimation();
      });
    }

    createMiddleAnimation() {
      const keyframes = [
        { opacity: 1, transform: 'translateY(0)', offset: 0.0 },
        { opacity: 1, transform: 'translateY(0)', offset: 1.0 },
      ];

      const options = {
        duration: this.duration,
        fill: 'both',
      };

      this.animation = this.animate(keyframes, options);
      this.animation.addEventListener('finish', () => {
        this.animation.commitStyles();
        this.animation.cancel();
        this.createFinishAnimation();
      });
    }

    createFinishAnimation() {
      const keyframes = [
        { opacity: 1, transform: 'translateY(0)', offset: 0.0 },
        { opacity: 0, offset: 0.5 },
        { opacity: 0, transform: `translateY(${this.translateYOffset})`, offset: 1.0 },
      ];

      const options = {
        duration: Themu.prefersReducedMotion ? 0 : 300,
        easing: Themu.animation.easeOut,
        fill: 'both',
      };

      this.animation = this.animate(keyframes, options);
      this.animation.addEventListener('finish', () => {
        this.animation.commitStyles();
        this.animation.cancel();
        this.remove();
      });
    }

    handleClickButtonDismiss() {
      this.animation.cancel();
      this.createFinishAnimation();
    }

    handleMouseEnter() {
      this.animation.pause();
    }

    handleMouseLeave() {
      this.animation.play();
    }
  }

  customElements.define('ce-toaster', Toaster);
  customElements.define('ce-toast', Toast);
})();
